import { Card, Heading } from '@etg/wings';
import { css, etiColors } from '@eti/styles';
import { DangerousHtmlContent } from '@eti/components';
import ProductReadMoreContent from '../bundle-overlay/ProductReadMoreContent';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const detailsWrapperStyles = css`
  color: ${etiColors.black};
  display: flex;
  font-size: 0.875rem;
  padding: 10px 0;
  position: relative;

  & li {
    padding-inline-start: 10px;
    position: relative;

    &::before {
      background-color: ${etiColors.black};
      border-radius: 50%;
      content: '';
      height: 4px;
      left: 0;
      position: absolute;
      top: 7px;
      width: 4px;
      [dir='rtl'] & {
        left: auto;
        right: 0;
      }
    }
  }
`;
const readMoreWrapperStyles = css`
  color: ${etiColors.black};
  display: flex;
  font-size: 0.875rem;
  position: relative;
`;
const BundleModalContent = _ref => {
  let {
    bundleName,
    bundleDescription,
    bundleReadMoreText
  } = _ref;
  return /*#__PURE__*/_jsxs(Card, {
    "data-testid": "ancillaryBundle-BundleHeader-details",
    children: [/*#__PURE__*/_jsx(Heading, {
      "data-testid": "ancillaryBundle-BundleHeader-title",
      level: 3,
      children: bundleName
    }), /*#__PURE__*/_jsx("div", {
      className: detailsWrapperStyles,
      children: /*#__PURE__*/_jsx(DangerousHtmlContent, {
        content: bundleDescription
      })
    }), bundleReadMoreText && /*#__PURE__*/_jsx("div", {
      className: readMoreWrapperStyles,
      children: /*#__PURE__*/_jsx(ProductReadMoreContent, {
        description: null,
        name: null,
        readMoreText: bundleReadMoreText,
        termsUrl: null
      })
    })]
  });
};
export default BundleModalContent;